<template>
  <div class="cookie-alert" v-show="visible">
    <div class="cookie-alert__box">
      <slot />
      <a href="" class="button" @click.stop.prevent="closeSiteAlert()">Принять</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieAlert",
  props: {

  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    this.checkCookies();
  },
  methods: {
    checkCookies() {
      if (localStorage.getItem('cookieAlertHidden') !== '1') {
        this.visible = true;
      }
    },
    closeSiteAlert() {
      localStorage.setItem('cookieAlertHidden', '1');
      this.visible = false;
    },
  }
};
</script>
